import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/app/global-error.tsx");
